export const PANEL_DEFAULT_WIDTH = 320;
export const PANEL_MIN_WIDTH = 320;
export const PANEL_MAX_WIDTH = "100%";

export const PANEL_DEFAULT_HEIGHT = 480;
export const PANEL_MIN_HEIGHT = 240;

export const PANEL_GAP = 12;
export const HEADER_HEIGHT = 56;
export const PANEL_EXIT_ANIMATION_DURATION = 150;

export const SIDE_ZONE_DEFAULT_WIDTH = 292;
export const SIDE_ZONE_MIN_WIDTH = 270;
export const SIDE_ZONE_DROP_THRESHOLD = 64;
export const SIDE_ZONE_PANEL_MIN_SIZE = 15;

export const MIN_VISIBLE = 10;
export const RESIZE_CLAMP_DEBOUNCE_MS = 150;
export const MAXIMIZED_PANEL_Z_INDEX = 50;

export const INITIAL_Z_INDEX = 10;
export const MAX_PANEL_Z_INDEX = 49;
